import React, { FC, ReactNode } from 'react';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import PageHeader from '@salesforce/design-system-react/components/page-header';
import PageHeaderControl from '@salesforce/design-system-react/components/page-header/control';
import Button from '@salesforce/design-system-react/components/button';
import '../../../index.scss';
import { USAGE_TYPE } from '../../../../../../util/constants';

interface Props {
  handleGeneratePdf: () => void;
  handleGenerateExcel: () => void;
  handleSubmit: () => void;
  handleReSubmitOrder: () => void;
  handleSave: () => void;
  viewOnly: boolean;
  isERPOrderFailed: boolean;
  orderResubmitPermission: boolean;
  usageDetails?: any;
  holddata?: any;
}

const SurgerySheetHeader: FC<Props> = ({
  handleGeneratePdf,
  handleGenerateExcel,
  handleSubmit,
  handleReSubmitOrder,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleSave,
  viewOnly,
  isERPOrderFailed,
  orderResubmitPermission,
  usageDetails,
  holddata,
}) => {
  const actions = (): ReactNode => (
    <PageHeaderControl>
      <Button
        label="Generate PDF"
        iconCategory="utility"
        iconName="paste"
        iconPosition="left"
        onClick={handleGeneratePdf}
      />
      {usageDetails?.orderType === USAGE_TYPE.SHIP_AND_BILL && (
        <Button
          label="Generate Excel"
          iconCategory="utility"
          iconName="table"
          iconPosition="left"
          onClick={handleGenerateExcel}
          style={{ marginLeft: 8 }}
        />
      )}
    </PageHeaderControl>
  );

  return (
    <IconSettings iconPath="/icons">
      <PageHeader
        className="slds-page-header-usage slds-page-header__name-title-inventory slds-m-around_small slds-m-bottom_none"
        onRenderActions={actions}
        title={<span style={{ fontSize: '18px' }}>Usage Sheet</span>}
        variant="record-home"
        id="header"
      />
    </IconSettings>
  );
};

export default SurgerySheetHeader;
